module.exports = __webpack_public_path__ + "img/Slide_1.430fcab9.jpg";